
import Component from '../../../assets/scripts/modules/component';
import {smartAddEventListener} from '../../../vendor/scripts/fabrique/helpers/eventlisteners';
import fireCustomEvent from '../../../vendor/scripts/fabrique/modules/fire-custom-event';
import {ellipsizeTextBox} from '../../../assets/scripts/modules/elements';
import State from '../../../assets/scripts/modules/state';

const Swiper = require('swiper/dist/js/swiper.min');

const swiperDefaults = {
  allowSlideNext: false,
  allowSlidePrev: false,
  direction: 'vertical',
  followFinger: false,
  keyboard: true,
  mousewheel: {
    releaseOnEdges: true,
  },
  resistance: false,
  slidesPerView: 'auto',
  spaceBetween: 0,
  speed: 600,
  touchReleaseOnEdges: true,
};

const IMAGE_CLASS = 'panels__item-image';

const STATE_FULLSCREEN = 1;
const STATE_INBETWEEN_FULLSCREEN_AND_START = 2;
const STATE_INBETWEEN_START_AND_FULLSCREEN = 3;
const STATE_START = 4;
const STATE_INBETWEEN_START_AND_SLIDER = 5;
const STATE_INBETWEEN_SLIDER_AND_START = 6;
const STATE_SLIDER = 7;

class Panels extends Component {

  constructor() {
    super(...arguments);
  }

  init() {

    this.wrapper = this.element.querySelector('.panels__wrapper');
    // this.panels = this.element.querySelectorAll('.panels__item');
    this.swiperContainer = this.element.querySelector('.swiper-container');
    this.remMeasure = this.element.querySelector('[data-role="panels--rem-measure"]');

    this.swiperInstance = null;
    this.swiperEnabled = false;
    this.slides = [...this.element.querySelectorAll('.swiper-slide')];
    this.numSlides = this.slides.length;
    this.maxIndex = this.numSlides - 1;
    this.initialToTopScroller = null;
    this.ieScrollDelay = 600;
    this.ieScrollDelayEnabled = false;
    this.lastScrollPosition = 0;

    this.state = STATE_FULLSCREEN;

    // No resize for now, because Swiper doesn't work well with this.
    window.addEventListener('resize', this.onResize.bind(this));

    window.addEventListener('intro:ended', () => {
      this.endFullscreen();
    });

    window.addEventListener('banner:ending', () => {
      this.element.classList.add('is-opening');
    });

    window.addEventListener('banner:ended', () => {
      if (this.state < STATE_SLIDER) {
        this.initSwiper();
        this.initMainFlow();

        this.enableSliderFlow();
      }

    });

    this.onResize();
  }

  initMainFlow() {
    /* Handling of mouse wheel events across the window. */
    smartAddEventListener(window, 'mousewheel DOMMouseScroll touchstart', (event) => {
      const direction = event.detail < 0 ? 'up' : (event.wheelDelta > 0 ? 'up' : 'down');

      if (this.swiperInstance.activeIndex !== this.maxIndex) {
        event.preventDefault();
      }

      /* Initial interaction */
      if (this.state === STATE_FULLSCREEN) {
        this.endFullscreen();
        return;
      } else if (this.state === STATE_START && direction === 'up') {
        this.enableSliderFlow();
        return;
      } else if (this.state < STATE_SLIDER) {
        return;
      } else if (direction === 'up' && this.state === STATE_SLIDER && this.swiperInstance.activeIndex === 0 && !this.swiperInstance.animating) {
        // TODO: handle this for touch
        this.backToBanner();
      }

      if (!this.swiperEnabled && window.pageYOffset <= 1) {
        this.swiperInstance.mousewheel.enable();
        this.swiperInstance.keyboard.enable();
        this.swiperEnabled = true;
        this.updateDotsState();
      } else if (this.swiperEnabled && this.swiperInstance.activeIndex === this.maxIndex && window.pageYOffset > 1) {
        this.swiperInstance.mousewheel.disable();
        this.swiperInstance.keyboard.disable();
        this.swiperEnabled = false;
        this.updateDotsState();
      }

      /* Stop touch propagation when swiper not enabled. */
      if (!this.swiperEnabled) {
        event.stopPropagation();
      }

    }, true);

    /* Bugged IE handling */
    window.addEventListener('scroll', () => {

      const direction = window.pageYOffset > this.lastScrollPosition ? 'down' : 'up';

      /* Initial interaction */
      if (this.state === STATE_FULLSCREEN) {
        this.endFullscreen();
      } else if (this.state === STATE_START && direction === 'down') {
        this.enableSliderFlow();
      }

      if (this.state < STATE_SLIDER) {
        return;
      }

      /* Default interaction */
      if (window.pageYOffset !== 1) {
        this.handleScrollInDirection(direction);
      }

      this.lastScrollPosition = window.pageYOffset;

    });
  }

  updateDotsState() {
    if (State.isLandscape()) {
      if (window.pageYOffset <= 1) {
        fireCustomEvent('menu-bar:enable-dots');
      } else {
        fireCustomEvent('menu-bar:disable-dots');
      }
    } else {
      if (this.state <= STATE_START) {
        fireCustomEvent('menu-bar:enable-dots');
      } else {
        fireCustomEvent('menu-bar:disable-dots');
      }
    }
  }

  initSwiper() {
    this.scrollToTop();

    if (!this.swiperInstance) {
      this.swiperInstance = new Swiper(this.swiperContainer, swiperDefaults);
      this.swiperInstance.on('slideChange', this.animateContent.bind(this));
      this.swiperInstance.on('slidePrevTransitionStart', () => {
        this.element.classList.add('going-up');
      });
      this.swiperInstance.on('slidePrevTransitionEnd', () => {
        this.element.classList.remove('going-up');
      });

      this.slides.forEach((slide, index) => {
        slide.querySelector('[data-role="slide--activate"]').addEventListener('click', () => {
          this.swiperInstance.slideTo(index);
        });
      });
    }

    this.animateContent();

  }

  endFullscreen() {
    this.state = STATE_INBETWEEN_FULLSCREEN_AND_START;
    this.element.classList.add('is-fullscreen');
    this.element.classList.remove('is-enlarged');

    setTimeout(() => {
      if (this.state === STATE_INBETWEEN_FULLSCREEN_AND_START) {
        document.querySelector('main').classList.remove('is-fullscreen');
        fireCustomEvent('menu-bar:enable-dots');
        this.state = STATE_START;
      }

    }, 400);

  }

  backToBanner() {
    this.state = STATE_INBETWEEN_SLIDER_AND_START;

    this.swiperInstance.allowSlideNext = false;
    this.swiperInstance.allowSlidePrev = false;
    this.element.classList.add('is-closing');
    this.element.classList.remove('is-closed');
    this.element.classList.remove('is-opening');

    setTimeout(() => {
      this.element.classList.remove('is-closing');
      if (this.state === STATE_INBETWEEN_SLIDER_AND_START) {
        this.element.classList.add('is-closed');
        this.element.classList.remove('is-closing');
        fireCustomEvent('home-banner:reactivate');
        this.state = STATE_START;
        this.updateDotsState();
        this.onResize();
      }

    }, 800);
  }

  enableSliderFlow() {
    this.state = STATE_INBETWEEN_START_AND_SLIDER;
    this.element.classList.add('is-opening');
    this.element.classList.remove('is-closed');
    this.element.classList.remove('is-closing');
    this.updateDotsState();

    setTimeout(() => {
      if (this.state === STATE_INBETWEEN_START_AND_SLIDER) {
        this.swiperInstance.allowSlideNext = true;
        this.swiperInstance.allowSlidePrev = true;
        this.element.classList.remove('is-opening');
        this.state = STATE_SLIDER;
        fireCustomEvent('home-banner:deactivate');
      }

    }, 600);

  }

  scrollToTop() {
    this.initialToTopScroller = setInterval(() => {

      if (window.pageYOffset !== 1) {
        window.scrollTo(0, 1);
      } else {
        clearInterval(this.initialToTopScroller);
      }

    }, 100);

  }

  animateContent() {
    const activeIndex = this.swiperInstance.activeIndex;
    const imageClassSelector = `.${IMAGE_CLASS}`;

    this.slides.forEach((slide, index) => {

      const imageClasses = [IMAGE_CLASS];

      if (index % 2 === 1 && index + 1 < activeIndex) {
        imageClasses.push('image-top-very-right');
      }

      if (index % 2 === 1 && index + 1 === activeIndex) {
        imageClasses.push('image-top-right');
      }

      if (index % 2 === 1 && index > activeIndex) {
        imageClasses.push('image-bottom-left');
      }

      if (index === 0 && index + 1 < activeIndex) {
        imageClasses.push('image-top-very-left');
      } else if (index % 2 === 0 && index < activeIndex) {
        imageClasses.push('image-top-left');
      }

      if (index % 2 === 0 && index > activeIndex) {
        imageClasses.push('image-bottom-right');
      }

      slide.querySelector(imageClassSelector).setAttribute('class', imageClasses.join(' '));

    });

  }

  handleScrollInDirection(direction) {
    if (this.swiperInstance.activeIndex !== this.maxIndex) {
      window.scrollTo(0, 1);

      if (!this.ieScrollDelayEnabled) {
        if (direction === 'down') {
          this.swiperInstance.slideNext();
        } else if (this.swiperInstance.activeIndex === 0 && this.state === STATE_SLIDER) {
          this.backToBanner();
        } else {
          this.swiperInstance.slidePrev();
        }
        this.ieScrollDelayEnabled = true;

        setTimeout(() => {
          this.ieScrollDelayEnabled = false;
        }, this.ieScrollDelay);
      }
    }
  }

  onResize() {
    const height = Number(window.innerHeight);
    // const width = Number(window.innerWidth);
    const rem = parseInt(State.getStyle(document.documentElement, 'font-size')) * .1;

    if (State.isLandscape()) {
      /* Landscape adjustments */
      const slideHeight = Math.floor(height - ((40 + 58) * rem));
      this.element.style.height = `${height}px`;
      this.element.querySelector('.swiper-container').style.height = `${slideHeight}px`;
      [...this.element.querySelectorAll('.swiper-slide')].forEach((slide) => {
        slide.style.height = `${slideHeight}px`;
      });
      [...this.element.querySelectorAll('.panels__item-default-text, .panels__item-mobile-text')].forEach(textbox => {
        textbox.innerText = textbox.getAttribute('data-original-text') || textbox.innerText;
      });
    } else {
      /* Mobile adjustments */
      this.element.style.height = `${height}px`;
      this.element.querySelector('.swiper-container').style.height = `${height - ((20 + 42) * rem)}px`;
      [...this.element.querySelectorAll('.swiper-slide')].forEach((slide) => {
        slide.style.height = `${height - ((20 + 42) * rem)}px`;
      });
      [...this.element.querySelectorAll('.panels__item-default-text, .panels__item-mobile-text')].forEach(textbox => {
        const originalText = textbox.innerText;
        textbox.setAttribute('data-original-text', textbox.getAttribute('data-original-text') || originalText);
        ellipsizeTextBox(textbox, originalText);
      });
    }

    this.updateDotsState();

  }
}

for (const element of document.querySelectorAll('.panels')) {
  element.instance = new Panels('panels', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/organisms/panels/panels.js